import * as corePixiInit from './core/initializePixi.js'

const loadAndExecuteFunction = (func) => (...args) =>
  corePixiInit.loadGameUIFunctions()
    .then((gameUI) => gameUI[func](...args))
    .catch((error) => {
      throw error
    })

const resetPixiGame = loadAndExecuteFunction('resetPixiGame')

export const pixiAppResize = (x, y) => {
  corePixiInit.resizePixiApp(x, y)
  resetPixiGame(x, y)
}

export const fruitFiestaApplicationInit = (pixiStates) => corePixiInit.init(pixiStates);

export const fruitFiestaApplicationLoad = (pixiStates) => corePixiInit.loadPixiAssets(pixiStates)

export const fruitFiestaApplicationDestroy = () => corePixiInit.destroyPixiApp();

export const isSimulate = false

